import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TagFormComponent } from './tag-form.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    TagFormComponent
  ],
  exports: [
    TagFormComponent
  ],
  entryComponents: [
    TagFormComponent
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule
  ]
})
export class TagFormModule { }
